/* eslint-disable no-use-before-define */
import React, { useEffect, useRef, useState } from "react";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutlineSharp";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { InputAdornment, makeStyles } from "@material-ui/core";
import { GetStatusResponse } from "../../models/basicInformation.model";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { prefixer, WEBKIT } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { useSelector } from "react-redux";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

interface MultiSelectCmpPropsType {
  options?: any[];
  onChange?: any;
  label?: string;
  value?: any;
  name?: string;
  id?: string;
  changeMultiSelect?: any;
  responseValue?: GetStatusResponse[];
  onBlur?: any;
  onSelect?: any;

  autocompleteKey?: any;

  defaultValue?: any;
}

let mainColor: any;

const useStyles = makeStyles((theme) => ({
  "& .muirtl-11j1b2e-MuiInputBase-root-MuiOutlinedInput-root": {
    color: "red !important",
    backgroundColor: "red !important",
  },
  root: {
    "& .MuiAutocomplete-inputRoot": {
      overflow: "hidden !important",
      flexWrap: "nowrap !important",
      textOverflow: "ellipsis !important",
      whiteSpace: "nowrap  !important",
      color: "#333",
      position: "initial",
    },
    "& .MuiChip-label": {
      overflow: "inherit !important",
    },
    "& .muirtl-11j1b2e-MuiInputBase-root-MuiOutlinedInput-root": {
      color: "#12354 !important",
      backgroundColor: "red !important",
    },
    // "& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment": {
    //     left: "32px !important", // probably the width of your search IconButton or more if needed
    // },
  },
  inputRoot: {
    overflow: "inherit !important",
    "& .MuiAutocomplete-inputRoot": {
      overflow: "hidden !important",
      flexWrap: "nowrap !important",
      textOverflow: "ellipsis !important",
      // maxWidth: '200px  !important',
      whiteSpace: "nowrap  !important",
      color: "#333",
    },
    "&.Mui-focused fieldset": {
      // borderColor: "#C52328 !important",
      borderColor: "green !important",
      borderWidth: "2px !important",
      position: "absolout !important",
    },
    "& .muirtl-11j1b2e-MuiInputBase-root-MuiOutlinedInput-root": {
      color: "red !important",
      backgroundColor: "red !important",
    },
  },
  option: {
    '&[aria-selected="true"]': {
      // backgroundColor: "#e3abed",
      backgroundColor: { mainColor },
    },

    "&:hover": {
      backgroundColor: "#0f8e2c",
    },
    backgroundColor: "#fff",
  },
}));

export default function AutoCompleteSearch(props: MultiSelectCmpPropsType) {
  // const [val, setVal] = useState<any[]>([]);
  const [val, setVal] = useState<any>();

  const classes = useStyles();

  const handleChange = (event: object, value: any) => {
    setVal(value);

    props.onChange(value?.id, value?.title);
    // let partialStudentDetails = value.map((item: any, index: number) =>
    //   value[index].id ? value[index].id : value[index]
    // );
    // changeMultiSelect(partialStudentDetails, value);
  };
  React.useEffect(() => {
    setVal(props.responseValue!);
  }, [props.responseValue]);
  const jsonFile = useSelector((state: any) => state.style);

  mainColor = jsonFile?.mainColor;
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <div dir="rtl" className="autoCompleteSearch-container">
          <Autocomplete
            className={jsonFile?.muiColor}
            key={props.autocompleteKey}
            onBlur={props.onBlur}
            onSelect={props.onSelect}
            style={{ position: "inherit", direction: "rtl" }}
            popupIcon={
              <KeyboardArrowDownIcon
              // style={{ position: "absolute", top: "0px", right: "130px" }}
              />
            }
            ChipProps={{ deleteIcon: <></> }}
            classes={classes}
            // multiple
            limitTags={1}
            id="multiple-limit-tags"
            filterSelectedOptions
            options={props.options!}
            // onChange={(e, newValue) => setVal(newValue)}
            onChange={handleChange}
            onInputChange={handleChange}
            getOptionLabel={(option) => option.title}
            value={val}
            defaultValue={props.defaultValue}
            renderInput={(params) => (
              <TextField
                {...params}
                label={props.label}
                classes={classes}
                color={jsonFile?.muiColor}
                // InputProps={{
                //     ...params.InputProps,
                //     endAdornment: (
                //         <InputAdornment position="start">
                //             <KeyboardArrowDownIcon />
                //         </InputAdornment>
                //     )
                // }}

                className="autoCompleteSearchField"
              />
            )}
            disableClearable={false}
          />
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
}
